import React from "react"

const SVGIcon = ({ name, ...otherProps }) => {
  const Component = require(`../../assets/svgs/${name}.svg`).default
  return <Component {...otherProps} />
}

export default SVGIcon
